<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 26 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<mask id="path-1-inside-1_1419_2081" fill="white">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M4.33333 9C6.17428 9 7.66667 10.5043 7.66667 12.36C7.66667 14.2157 6.17428 15.72 4.33333 15.72C2.49238 15.72 1 14.2157 1 12.36C1 10.5043 2.49238 9 4.33333 9ZM12.9996 9C14.8405 9 16.3329 10.5043 16.3329 12.36C16.3329 14.2157 14.8405 15.72 12.9996 15.72C11.1586 15.72 9.66625 14.2157 9.66625 12.36C9.66625 10.5043 11.1586 9 12.9996 9ZM24.9987 12.36C24.9987 10.5043 23.5063 9 21.6654 9C19.8244 9 18.332 10.5043 18.332 12.36C18.332 14.2157 19.8244 15.72 21.6654 15.72C23.5063 15.72 24.9987 14.2157 24.9987 12.36Z"
				/>
			</mask>
			<path
				d="M7.66667 12.36H9.22667C9.22667 9.6545 7.04754 7.44 4.33333 7.44V9V10.56C5.30102 10.56 6.10667 11.3541 6.10667 12.36H7.66667ZM4.33333 15.72V17.28C7.04754 17.28 9.22667 15.0655 9.22667 12.36H7.66667H6.10667C6.10667 13.3659 5.30102 14.16 4.33333 14.16V15.72ZM1 12.36H-0.56C-0.56 15.0655 1.61912 17.28 4.33333 17.28V15.72V14.16C3.36564 14.16 2.56 13.3659 2.56 12.36H1ZM4.33333 9V7.44C1.61912 7.44 -0.56 9.6545 -0.56 12.36H1H2.56C2.56 11.3541 3.36564 10.56 4.33333 10.56V9ZM16.3329 12.36H17.8929C17.8929 9.6545 15.7138 7.44 12.9996 7.44V9V10.56C13.9673 10.56 14.7729 11.3541 14.7729 12.36H16.3329ZM12.9996 15.72V17.28C15.7138 17.28 17.8929 15.0655 17.8929 12.36H16.3329H14.7729C14.7729 13.3659 13.9673 14.16 12.9996 14.16V15.72ZM9.66625 12.36H8.10625C8.10625 15.0655 10.2854 17.28 12.9996 17.28V15.72V14.16C12.0319 14.16 11.2262 13.3659 11.2262 12.36H9.66625ZM12.9996 9V7.44C10.2854 7.44 8.10625 9.6545 8.10625 12.36H9.66625H11.2262C11.2262 11.3541 12.0319 10.56 12.9996 10.56V9ZM21.6654 9V10.56C22.6331 10.56 23.4387 11.3541 23.4387 12.36H24.9987H26.5587C26.5587 9.6545 24.3796 7.44 21.6654 7.44V9ZM18.332 12.36H19.892C19.892 11.3541 20.6977 10.56 21.6654 10.56V9V7.44C18.9512 7.44 16.772 9.6545 16.772 12.36H18.332ZM21.6654 15.72V14.16C20.6977 14.16 19.892 13.3659 19.892 12.36H18.332H16.772C16.772 15.0655 18.9512 17.28 21.6654 17.28V15.72ZM24.9987 12.36H23.4387C23.4387 13.3659 22.6331 14.16 21.6654 14.16V15.72V17.28C24.3796 17.28 26.5587 15.0655 26.5587 12.36H24.9987Z"
				:fill="color"
				mask="url(#path-1-inside-1_1419_2081)"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgMore',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
